import { render, staticRenderFns } from "./ExchangeRateComponent.vue?vue&type=template&id=51f40095&"
import script from "./ExchangeRateComponent.vue?vue&type=script&lang=js&"
export * from "./ExchangeRateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports